import { axiosRequest } from '@/util/axios-request'

// 获取薪资项目管理-list
export const payrollManageList = data =>
  axiosRequest({
    url: '/web/payroll_setting/managelist',
    method: 'GET',
    params: data
  })
  // 编辑群勤奖规则
export const saveFullAttendanceBonus = data =>
  axiosRequest({
    url: '/web/payroll_setting/saveFullAttendanceBonus',
    method: 'POST',
    data
  })

// 设置薪资项目状态
export const updateSettingStatus = data =>
  axiosRequest({
    url: '/web/payroll_setting/updateSettingStatus',
    method: 'POST',
    data
  })

// 全勤奖设置list
export const fullAttendanceBonusList = data =>
  axiosRequest({
    url: '/web/payroll_setting/fullAttendanceBonusList',
    method: 'GET',
    params: data
  })
